import React from 'react';
import { GetImageUrl } from 'utilities/media/media-util';
import { OptionButton as FuseOptionButton } from '@tvg/fuse/option-button';
import { getSite } from 'context/SiteContext';
import styles from './OptionButton.module.css';

type Props = {
  name: string;
  id: string;
  label: string;
  swatchColour?: string;
  swatchImage?: string;
  checked: boolean;
  disabled: boolean;
  handleOnClick: (e: React.MouseEvent<HTMLInputElement>) => void;
};

function OptionButton(props: Props) {
  const { name, id, label, swatchColour, swatchImage, checked, disabled, handleOnClick } = props;
  const site = getSite();

  const buildImageSwatchURL = (swatchImageValue?: string) => {
    let swatchImageURL = null;

    if (swatchImageValue) {
      swatchImageURL = GetImageUrl({ identifier: swatchImageValue, template: '$19x19_standard', format: 'jpg', site });
    }

    return swatchImageURL;
  };

  return (
    <div className={styles.wrapper}>
      <FuseOptionButton
        key={id}
        id={id}
        name={id}
        dataTestId={`option-selector-button-${id.toLowerCase()}`}
        label={name === 'colour' ? label.toLowerCase() : label}
        swatchImage={buildImageSwatchURL(swatchImage)}
        swatchColour={swatchColour}
        checked={checked}
        disabled={disabled}
        onClick={handleOnClick}
      />
    </div>
  );
}

export default OptionButton;
